import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import indhumathidoc from '../../../../assets/images/Doctorsimages/dr.indhumathi.png'
import favicon from "../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const IndhumathiDoc = () => {
  const navigate = useNavigate(); 
  
  useEffect(() => {
    document.title = "Dr. Indhumathi M. | Best Homeopathy Specialist in Chennai | H-Cura Multispeciality Clinic";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Indhumathi M. (BHMS, D.Yoga), a dedicated Homeopathic Physician at H-Cura Multispeciality Clinic, Chennai. Specializing in constitutional homeopathy and individualized natural healing for chronic and acute conditions."
      );
    }
    
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best homeopathy doctor in Chennai, homeopathic physician near me, H-Cura Multispeciality Clinic homeopathy, constitutional homeopathy specialist, natural healing doctor Chennai, female homeopathy doctor, homeopathy for chronic illness, Saradha Krishna Homoeopathic Medical College alumni"
      );
    }

    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalUrl = "https://www.h-cura.com/doctors/dr-indhumathi-m-bhms-yoga-homeopathy-chennai";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalUrl);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalUrl);
      document.head.appendChild(canonicalLink);
    }

    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');
    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');
    
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    const images = container.querySelectorAll('img');
    images.forEach(img => { img.style.opacity = '1'; });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        backgroundColor: '#ffffff',
        logging: false,
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
        scrollY: -window.scrollY,
        scrollX: -window.scrollX,
        imageTimeout: 0,
        removeContainer: false
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvasWidth;
        const imgWidth = canvasWidth * scaleFactor;
        const imgHeight = canvasHeight * scaleFactor;
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr.Indhumathi_Homeopathy_Profile.pdf');
      }).catch(error => {
        console.error('Error generating PDF:', error);
        container.classList.remove('veenadoc-pdf-mode');
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Indhumathi M.</span>
                  <span className="veenadoc-title-credentials">(B.H.M.S., D.Yoga)</span>
                  <span className="veenadoc-title-location">Chennai</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A compassionate and highly trained <strong>Homeopathic Physician</strong> at H-Cura Multispeciality Clinic, dedicated to the art of natural healing. Dr. Indhumathi specializes in a patient-centered approach that prioritizes individualized treatment to achieve long-term wellness and harmony.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img 
                        src={indhumathidoc} 
                        alt="Dr. Indhumathi M. – Homeopathic Physician at H-Cura Multispeciality Clinic" 
                        className="veenadoc-doctor-image" 
                        title='Dr. Indhumathi M. | Best Homeopathy Specialist in Chennai' 
                      />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>Expertise in Homeopathic Healing</h2>
                  <p>
                    Dr. Indhumathi M. (B.H.M.S., D.Yoga) is a dedicated Homeopathic Physician who believes in the power of the "individual" over the "disease." Currently practicing at <strong>H-Cura Multispeciality Clinic</strong>, she is a trusted name for patients seeking profound, root-cause-based healing through the precise science of Homeopathy.
                  </p>
                  <p>
                    Her practice is defined by deep clinical insights and a commitment to restoring health naturally without the burden of side effects.
                  </p>
                </div>

                {/* Academic Excellence */}
                <div className="veenadoc-article-block">
                  <h2>Academic Excellence & Clinical Foundation</h2>
                  <p>
                    Dr. Indhumathi completed her Bachelor of Homeopathic Medicine and Surgery (B.H.M.S.) at the renowned <strong>Saradha Krishna Homoeopathic Medical College, Kanyakumari</strong>. Her rigorous academic journey included an intensive internship where she gained extensive experience in treating both acute and chronic pathologies.
                  </p>
                  <p>
                    To complement her medical foundation, she also holds a <strong>Diploma in Yoga (D.Yoga)</strong>, which informs her holistic understanding of physical and mental discipline in the recovery process.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Professional Info</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">B.H.M.S., D.Yoga</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Constitutional Homeopathy</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Clinic:</span>
                      <span className="veenadoc-info-value">H-Cura Multispeciality Clinic</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Locations:</span>
                      <span className="veenadoc-info-value">Chennai</span>
                    </div>
                  </div>
                </div>

                {/* Treatment Philosophy */}
                <div className="veenadoc-article-block">
                  <h2>Treatment Philosophy: Patient-Centered & Individualized</h2>
                  <p>
                    Dr. Indhumathi’s practice is built on the core homeopathic principle that no two patients are the same. She understands that every individual expresses illness in a unique way, and therefore, their cure must be equally unique.
                  </p>
                  <blockquote className="veenadoc-philosophy-quote" style={{borderLeft: '4px solid #2e7d32', paddingLeft: '15px', fontStyle: 'italic', margin: '20px 0'}}>
                    "I practice a holistic, patient-centered approach based on individualized homeopathic principles, focusing on the person behind the patient to trigger the body's innate healing mechanisms."
                  </blockquote>
                  <p>
                    This deep-dive approach ensures that lifestyle, emotional state, and physical symptoms are all considered to achieve lasting results.
                  </p>
                </div>

                {/* Areas of Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Specialized Homeopathic Expertise</h2>
                  <p>
                    At H-Cura, Dr. Indhumathi provides expert care across several key areas:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li><strong>Constitutional Homeopathy:</strong> Treating chronic conditions by addressing the patient’s overall physical and mental makeup.</li>
                    <li><strong>Acute Care:</strong> Providing safe and effective homeopathic solutions for seasonal ailments, infections, and sudden illnesses.</li>
                    <li><strong>Lifestyle Management:</strong> Guiding patients through natural transitions to improve immunity and vitality.</li>
                    <li><strong>Holistic Wellness:</strong> Addressing the root causes of lifestyle disorders for sustainable recovery.</li>
                  </ul>
                </div>

                {/* Why Choose */}
                <div className="veenadoc-article-block">
                  <h2>Why Choose Dr. Indhumathi M. at H-Cura?</h2>
                  <p>
                    For families searching for a <strong>homeopathy doctor in Chennai</strong> who offers more than just a prescription, Dr. Indhumathi provides a sanctuary for healing. Her background at one of India's leading homeopathic colleges, combined with her empathetic nature, makes her an ideal partner in your health journey.
                  </p>
                  <p>
                    She is dedicated to providing side-effect-free, long-term health solutions that help patients regain their strength and confidence at <strong>H-Cura Multispeciality Clinic</strong>.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Your Partner in Natural Health</h2>
                  <p>
                    Choosing Dr. Indhumathi M. means choosing a professional who listens, understands, and applies the highest standards of homeopathic science. Visit her at <strong>H-Cura Multispeciality Clinic</strong> to experience the benefits of personalized natural medicine.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Our Mission:</strong> To empower patients with a powerful, non-invasive path to recovery through individualized homeopathic care.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote style={{fontSize: '14px'}}>
                      "True health is a state of complete physical and mental harmony achieved through individualized care."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Indhumathi's Philosophy</p>
                  </div>
                </div>

                {/* Practice Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Location</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>H-Cura Multispeciality Clinic</h4>
                      <p>Chennai, Tamil Nadu</p>
                      <p><small>Homeopathy Department</small></p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience the science of individualized homeopathy with Dr. Indhumathi at H-Cura.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Call to Schedule</span>
                  </button>
                  <button className="veenadoc-sidebar-btn-secondary" onClick={() => navigate('/bookconsultation')}>
                    <span>💬</span>
                    <span>Online Booking</span>
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

   

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download Dr. Indhumathi's Profile (PDF)
        </button>
      </div>
    </>
  )
}

export default IndhumathiDoc;
